<template>
  <div
    class="switch-buttons-language d-flex align-items-center justify-content-between"
  >
    <img
      :src="$i18n.locale == $const.LANG_JP ? imgFlagJP : imgFlagUK"
      alt="icon-flag"
      width="24"
      :class="$i18n.locale == $const.LANG_JP && 'box-shadow-flag'"
    />
    <div class="switch-buttons-box ml-2">
      <button
        type="button"
        class="btn t12"
        :class="$i18n.locale == $const.LANG_JP ? 'button-active' : 'button-normal -mr-3'" 
        @click="setLang('ja')"
      >日本語</button>
      <button 
        type="button" 
        class="btn t12" 
        :class="$i18n.locale == $const.LANG_EN ? 'button-active' : 'button-normal -ml-3'" 
        @click="setLang('en')"
      >English</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonToggleLanguage",
  props: {
    callback: {
      type: Function,
    },
  },
  data() {
    return {
      imgFlagJP:
        "https://static.phdvasia.com/jp/hut-rewards/japan.png",
      imgFlagUK: 
        "https://static.phdvasia.com/jp/hut-rewards/uk-flag.png"
    };
  },
  methods: {
    setLang: function (lang) {
			this.$store.dispatch('setLang', lang)
			this.$session.set('lang', lang)
      const langText = lang === this.$const.LANG_JP ? 'Japanese' : 'English'
      this.eventChangedLanguage(langText)
			this.$router.go(this.$router.currentRoute)
		}
  },
};
</script>

<style lang="scss" scoped>
.switch-buttons-language {
  .switch-buttons-box {
    background: #e9ebee;
    border-radius: 20px;
    .t12 {
      font-size: 12px;
    }
    .button-active {
      border-radius: 20px;
      background: white;
      margin: 3px;
      color: #70a401;
      padding: 4px 8px;
    }
    .button-normal {
      color: #6b6e79;
      margin: 3px;
      padding: 4px 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Buttons/ButtonToggleLanguage.vue